module.exports = __webpack_public_path__ + "static/media/arrow-alt-from-right.f4c1950a.svg";